import { render, staticRenderFns } from "./PICUPT.vue?vue&type=template&id=3d1d5c23&"
import script from "./PICUPT.vue?vue&type=script&lang=js&"
export * from "./PICUPT.vue?vue&type=script&lang=js&"
import style0 from "./PICUPT.vue?vue&type=style&index=0&id=3d1d5c23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports